import React, { useEffect, useMemo, useState } from "react"
import instacartDiscountIcon from "../../../../images/instacart_discount_icon.svg"
import { ReactComponent as CalendarIcon } from "../../../../images/appointment-only.svg"
import { ReactComponent as MapPin } from "../../../../images/map-pin.svg"
import { connect } from "react-redux"
import {
  Button,
  Checkbox,
  Divider,
  Image,
  Modal,
  Form,
  FormField,
  Message,
  Card,
  AccordionTitle,
  Icon,
  AccordionContent,
  Accordion
} from "semantic-ui-react"
import { routerPaths } from "../../../../v1/constants/paths"
import { Link, Redirect } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { isMobile } from "react-device-detect"
import LoadingComponent from "../../../../v1/components/LoadingComponent"
import { createOrder, updateOrder } from "../../../../v1/actions/orders"
import { me, optInForMarketing } from "../../../../v1/actions/user"
import {
  gaJSON,
  logPurchase,
  orderBookedEvents,
  trackFirebaseAnalytics
} from "../../../../shared_component/utils/googleAnalyticsHelpers"
import PaymentMethod from "../../../../v1/components/PaymentMethods/PaymentMethod"
import caShortLogo from "../../../../images/ca-orange-short.svg"
import AffirmLogo from "../../../../images/affirm-logo.svg"
import {
  EBAY,
  INSTACART,
  INSTACART_CA_NO_TIER,
  INSTACART_CANADA
} from "../../../../v1/constants/affiliations"
import ReviewServices from "./ReviewServices"
import AddPaymentDetails from "../AddPaymentDetails"
import { getUpdatedCart, isEbayTireOrder } from "../../../../v1/helpers/orderHelpers"
import { ReactComponent as InfoIcon } from "../../../../images/info-Icon.svg"
import cartWarningLogo from "../../../../images/cartWarningLogo.svg"
import { updateInfo } from "../../../../v1/actions/user"
import { getSubdomain } from "../../../../v1/components/Config/StylesheetInjector"
import { isEbay, isEbayUser } from "../../../../v1/helpers/affiliationHelpers"
import { formatPhoneNumber } from "../../../utils/formatPhoneNumber"
import { WHEEL_ALIGNMENT } from "../../../../v1/actions/services"
import { withRouter } from "react-router"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCar } from "@fortawesome/pro-regular-svg-icons"
import { showDateTime } from "../../Dashboard/NewUpcomingAppointmentCard"
import priceTagBlack from "../../../../images/price-tag-black.svg"
import ApplyPromotionV2 from "../../ApplyPromotionV2"
import { BottomSheet } from "react-spring-bottom-sheet"
import { ReactComponent as PaymentCard } from "../../../../images/payment-card.svg"
import { PricedAtShop } from "../PricedAtShop"
import { CA } from "../../../../v1/constants/states"
import UpsellServices from "./UpsellServices"
import { ReactComponent as Tick } from "../../../../images/tick-dynamic.svg"
import { AFFIRM, BRAINTREE } from "../../../../v1/constants/tires"
import { getPaymentMethods } from "../../../../v1/actions/paymentMethods"
import { isCanada } from "../../../../v1/helpers/translationHelpers"

const ReviewRequest = ({
  cart,
  activeVehicle,
  createOrder,
  updateOrder,
  optInForMarketing,
  t,
  user,
  braintreePaymentMethods,
  order,
  updateInfo,
  history,
  membershipData,
  location,
  getPaymentMethods,
  isCart
}) => {
  const [orderId, setOrderId] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [customerNote, setCustomerNote] = useState("")
  const [marketingOptIn, setMarketingOptIn] = useState(false)
  const isEbayTireCart = isEbayUser(user) && isEbayTireOrder(cart)
  const [mobileNumber, setMobileNumber] = useState("")
  const [mobileNumberError, setMobileNumberError] = useState("")
  const [showMarketingCheckbox, setShowMarketingCheckbox] = useState(false)
  const isInstacartUser = [INSTACART, INSTACART_CANADA].includes(
    user?.affiliation?.root_reference_id
  )
  const sub_total = cart ? cart.estimated_total_pre_tax - cart.transaction_fee : 0
  const defaultPaymentMethod = braintreePaymentMethods.find((method) => method.isdefault)
  const upgradeMembership =
    new URLSearchParams(location.search).get("upgrade_membership") === "true"

  const hasWheelAlignment = cart.order_services.find(
    (service) => service?.reference_id === WHEEL_ALIGNMENT
  )

  const [useAffirmPayment, setUseAffirmPayment] = useState(false)

  useEffect(() => {
    if (user?.cellPhone && user?.cellPhone !== "0000000000") {
      setMobileNumber(formatPhoneNumber(user.cellPhone) || "")
    }
    const userOptedForMarketing = user?.marketing_opt_in || false
    setMarketingOptIn(userOptedForMarketing)
    loadPaymentData()
  }, [])

  const loadPaymentData = async () => {
    if (!braintreePaymentMethods || braintreePaymentMethods.length == 0) {
      await getPaymentMethods(user)
    }
  }

  const handleMobileNumberChange = (e) => {
    const formattedPhoneNumber = formatPhoneNumber(e.target.value)
    setMobileNumber(formattedPhoneNumber)
    const phoneNumber = formattedPhoneNumber.replace(/[^\d]/g, "")
    if (phoneNumber.length === 10) {
      setMobileNumberError("")
    } else {
      setMobileNumberError(t("Please enter a valid phone number."))
    }
  }

  const handleCustomerNote = (e) => {
    setCustomerNote(e.target.value)
  }

  const handleMarketingOptIn = async () => {
    setMarketingOptIn(!marketingOptIn)
  }

  useEffect(() => {
    trackFirebaseAnalytics({
      event: gaJSON.checkout_start,
      params: {
        cart_value: cart.estimated_total || 0,
        service_count: cart.order_services.length || 0,
        returning_user: user.total_shop_orders > 0 ? "true" : "false"
      }
    })
  }, [])

  const onSubmit = async () => {
    if (
      hasWheelAlignment &&
      braintreePaymentMethods.length === 0 &&
      cart.payment_type !== "affirm"
    ) {
      history.push({
        pathname: routerPaths.addPayment
      })
      return
    }
    setIsSubmitting(true)
    try {
      const phoneNumber = mobileNumber?.replace(/[^\d]/g, "") || ""
      if (isEbayTireCart && phoneNumber != user.cellPhone) {
        await updateInfo({
          cellPhone: phoneNumber
        })
      }

      if (useAffirmPayment) {
        cart.payment_type = "affirm"
      } else {
        cart.payment_type = BRAINTREE
      }

      const response = order
        ? await updateOrder(cart, order)
        : await createOrder(cart.id, null, customerNote)
      const orderId = response.result ? response.result.id : response
      if (orderId) {
        setOrderId(orderId)
        logPurchase(response.result.currency.toUpperCase(), response.result.total)
        await orderBookedEvents({ response, orderId, activeVehicle })
      }
      if (isEbay()) {
        if (marketingOptIn) {
          await optInForMarketing({
            marketing_opt_in: marketingOptIn
          })
        }
        trackFirebaseAnalytics({
          event: gaJSON.ebay_booking_confirmed,
          params: {
            order_id: orderId,
            cart_value: response.result.total
          }
        })
      }
      trackFirebaseAnalytics({
        event: gaJSON.checkout_complete,
        params: {
          order_id: orderId,
          total_amount: response.result.total,
          payment_method_type: response.result.payment_type
        }
      })
      setIsSubmitting(false)
    } catch (error) {
      setIsSubmitting(false)
      trackFirebaseAnalytics({
        event: gaJSON.EtoB_confirm_service_request_error
      })
    }
  }

  let discountLogo = caShortLogo
  if (isInstacartUser) {
    discountLogo = instacartDiscountIcon
  }

  const showServices = () => {
    if (isEbayTireOrder(cart)) {
      return hasWheelAlignment ? true : false
    }
    return true
  }

  const [activeIndex, setActiveIndex] = useState(-1)

  const handleClick = (e, titleProps) => {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index
    setActiveIndex(newIndex)
  }

  const canBook = () => {
    const isMissingCartInfo = !cart.shop && !cart.appointment_date_pretty
    const noServices = cart.order_services.length === 0
    const invalidEbayTire = isEbayTireCart && (!mobileNumber || !!mobileNumberError)
    const needPayment =
      ((isEbayTireCart ? false : cart.no_order_service_has_shop_price) ||
        cart.estimated_total > 0) &&
      !(defaultPaymentMethod?.token || useAffirmPayment)
    return isMissingCartInfo || isSubmitting || noServices || invalidEbayTire || needPayment
  }

  const instacartPromo = isInstacartUser
    ? cart?.promotions?.find((p) => p.instacart_membership_discount)
    : null

  const membership = useMemo(() => {
    if (!membershipData?.length) return null
    return [...membershipData].find((plan) => plan.name === "Premium")
  }, [membershipData])

  const features = [
    `Get up to ${Math.trunc(membership?.percent_discount ?? 0)}% off all service & repairs`,
    "Talk to a Master Mechanic, any time",
    `Manage up to ${membership?.max_num_vehicles ?? 0} vehicles`
  ].filter(Boolean)

  const upsellMembershipFeatures = [
    `Premium Members Save ${Math.trunc(membership?.percent_discount ?? 0)}%`
  ]

  useEffect(() => {
    if (cart.payment_type === AFFIRM) {
      setUseAffirmPayment(true)
    } else if (cart.payment_type === BRAINTREE) {
      setUseAffirmPayment(false)
    }
  }, [cart.payment_type])

  const showUpsellBanner = () => {
    return !(
      isEbayUser(user) ||
      user?.total_shop_orders === 0 ||
      user?.membership?.plan_name !== "Basic" ||
      isCanada(user?.country) ||
      cart?.estimated_total < 100
    )
  }

  useEffect(() => {
    if (showUpsellBanner()) {
      trackFirebaseAnalytics({
        event: gaJSON.premium_upsell_interaction,
        params: {
          interaction_type: "view",
          ui_location: "review_request"
        }
      })
    }
  }, [cart?.estimated_total])

  const upsellMembershipBannerClick = () => {
    try {
      trackFirebaseAnalytics({
        event: gaJSON.premium_upsell_interaction,
        params: {
          interaction_type: "click",
          ui_location: "review_request",
          cart_value: cart?.estimated_total
        }
      })
      history.push(routerPaths.upsellMembership)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      {orderId && <Redirect to={`/appointment-confirm/${orderId}`} />}
      {cart && cart.shop ? (
        <div className="review-request-container">
          <div className="section">
            {isEbayUser() && cart?.promotional_discount > 0 && (
              <>
                <div className="discount-banner">
                  <div className="discount-banner-text">
                    <img className="discount-icon-review" src={discountLogo} />$
                    {cart?.promotions[0]?.discount} {cart?.promotions[0]?.name}
                  </div>
                </div>
                <div className="spacer-20" />
              </>
            )}
            {instacartPromo && (
              <>
                <div className="discount-banner">
                  <div className="discount-banner-text">
                    <img className="discount-icon-review" src={discountLogo} />
                    {instacartPromo.discount}% {instacartPromo.name}
                  </div>
                </div>
                <div className="spacer-20" />
              </>
            )}
            <div>
              <div className="heading-size-18" style={{ fontWeight: 700 }}>
                Service Details
              </div>
            </div>
            <div className="appointment-details">
              {activeVehicle && (
                <div className="date-row">
                  <FontAwesomeIcon icon={faCar} />
                  <p>
                    {activeVehicle.year || ""} {activeVehicle.make || ""}{" "}
                    {activeVehicle.model || ""}
                  </p>
                </div>
              )}
              <div className="row-space-between">
                <div className="date-row">
                  <MapPin className="calendar-icon" />
                  <div className="shop-details">
                    <p>{cart.shop?.name},</p>
                    <p className="text-normal">{cart.shop?.address_line1},</p>
                    <p className="text-normal">{`${cart.shop?.city}, ${cart.shop?.state}, ${cart.shop?.zip}`}</p>
                  </div>
                </div>
                {isCart && (
                  <Link
                    className="link-text"
                    to={routerPaths.shopSelection}
                    onClick={() => {
                      trackFirebaseAnalytics({
                        event: gaJSON.EtoB_change_selected_shop_review_page
                      })
                    }}
                  >
                    {t("change")}
                  </Link>
                )}
              </div>
              <div className="row-space-between">
                <div className="date-row">
                  <CalendarIcon className="calendar-icon" />
                  <p>{showDateTime(cart, t)}</p>
                </div>
                <Link
                  className="link-text"
                  to={routerPaths.appointment}
                  onClick={() => {
                    trackFirebaseAnalytics({
                      event: gaJSON.EtoB_change_appointment_review_page
                    })
                  }}
                >
                  {t("change")}
                </Link>
              </div>
            </div>

            {isEbayTireCart && (
              <div className="mobile-number">
                {(!user?.cellPhone ||
                  user?.cellPhone === "" ||
                  user?.cellPhone == "0000000000") && (
                  <Card fluid className="mobile-number-info">
                    <Image src={cartWarningLogo} />
                    {t(
                      "Please enter a valid mobile number to continue. We use this number to send important SMS updates about your appointment."
                    )}
                  </Card>
                )}
                <Form>
                  <FormField error={mobileNumberError.length > 0}>
                    <label className="mobile-label">
                      {t("Mobile Phone Number")} <span style={{ color: "red" }}> *</span>
                    </label>
                    <input
                      maxLength={14}
                      placeholder={t("e.g., 307-345-7618")}
                      value={mobileNumber}
                      onChange={handleMobileNumberChange}
                    />
                    {mobileNumberError && (
                      <Message size="mini" negative>
                        {mobileNumberError}
                      </Message>
                    )}
                  </FormField>
                </Form>
              </div>
            )}

            {showServices() && (
              <>
                <Divider style={{ margin: 0 }} />
                <ReviewServices
                  handleCustomerNote={handleCustomerNote}
                  customerNote={customerNote}
                />
              </>
            )}
          </div>
          <div className="priced-at-shop-banner green-banner">
            <InfoIcon style={{ width: "24px" }} />
            <div className="text-block">
              <span>{t("onlyChargedWhen")} </span>
            </div>
          </div>
          {user.affiliation.root_reference_id === INSTACART_CANADA &&
            user.affiliation.name !== INSTACART_CA_NO_TIER && (
              <div className="membership-summary payment-details-section">
                <div className="top-section">
                  <div className="title-block">
                    <p className="membership-title">Premium membership</p>

                    <div className="status-row">
                      <img className="discount-icon-review" src={instacartDiscountIcon} />
                      <p className="status-text">Active & Funded</p>
                    </div>
                  </div>

                  <div className="feature-list-review">
                    {features.map((feature, i) => (
                      <div className="feature-item" key={i}>
                        <Tick />
                        <p>{feature}</p>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="price-section">
                  <p className="price-old">${membership.price}</p>
                  <p className="price-included">Included with {user.affiliation_name} perks</p>
                </div>
              </div>
            )}
          {(!isEbayTireCart || cart.estimated_total > 0) && (
            <div className="payment-details-section">
              <div className="payment-method-review">
                <div className="row-space-between">
                  <span className="payment-header">Payment details</span>
                </div>
                <Divider style={{ marginTop: 5 }} />
                {!useAffirmPayment && defaultPaymentMethod && defaultPaymentMethod.token && (
                  <div className="default-payment-method">
                    <PaymentMethod
                      key={defaultPaymentMethod.token}
                      paymentMethod={defaultPaymentMethod}
                      hideDelete={true}
                      hideSetDefault={true}
                    />
                    <span onClick={() => setOpenModal(true)} className="change-payment">
                      Change
                    </span>
                  </div>
                )}
                {useAffirmPayment && (
                  <div className="affirm-payment-method">
                    <Image src={AffirmLogo} alt="Affirm-Logo" />
                    <span onClick={() => setOpenModal(true)} className="change-payment">
                      Change
                    </span>
                  </div>
                )}
                {!useAffirmPayment && !defaultPaymentMethod?.token && (
                  <div onClick={() => setOpenModal(true)} className="no-payment-section">
                    <div className="icon-circle">
                      <PaymentCard style={{ color: "#E95832" }} />
                    </div>
                    <div className="details-box">
                      <p className="text-bold-lg">Add payment method</p>
                      <p className="text-gray-sm">Credit card, PayPal, or Affirm</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="payment-summary-section">
            <Accordion style={{ fontFamily: "Inter" }}>
              <AccordionTitle active={activeIndex === 0} index={0} onClick={handleClick}>
                <Icon
                  className="accordion_icon"
                  name={activeIndex === 0 ? "chevron up" : "chevron right"}
                />
                <b className="text-bold-18" style={{ color: "#3c3c3c" }}>
                  {user.country === CA ? "Savings summary" : "Payment summary"}
                </b>
                <Divider style={{ margin: 0, marginTop: 5 }} />
              </AccordionTitle>
              <AccordionContent active={activeIndex === 0}>
                <div className="payment-summary-content">
                  {!cart?.opt_in_discount &&
                    ((user &&
                      user.country === "ca" &&
                      cart &&
                      cart.promotions.length > 0 &&
                      cart.promotions[0].discount > 0) ||
                      (cart &&
                        cart.any_order_service_lacks_price &&
                        cart.promotions.length > 0 &&
                        cart.promotions[0].discount > 0)) && (
                      <>
                        <div className="row-space-between">
                          {isInstacartUser ? (
                            <div style={{ display: "flex", gap: "10px" }}>
                              <div className="promotional-discount">{t("instacartBenefit")}</div>
                              <img className="discount-icon-review" src={instacartDiscountIcon} />
                            </div>
                          ) : (
                            <div className="promotional-discount">{t("carAdviseBenefit")}</div>
                          )}
                          <div className="font-bold">-{cart.promotions[0].discount}%</div>
                        </div>
                      </>
                    )}
                  {user && user.country !== "ca" && cart.promotional_discount > 0 && (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div className="row-space-between">
                        {isInstacartUser ? (
                          <div style={{ display: "flex", gap: "10px" }}>
                            <div className="promotional-discount">{t("instacartDiscount")}</div>
                            <img className="discount-icon-review" src={instacartDiscountIcon} />
                          </div>
                        ) : user?.marketing_opt_in && isEbayUser ? (
                          <div className="promotional-discount">{cart?.promotions[0]?.name}*</div>
                        ) : (
                          <div className="promotional-discount">{t("carAdviseDiscount")}</div>
                        )}
                        <div className="font-bold" style={{ color: "#282828" }}>
                          -${cart?.promotional_discount?.toFixed?.(2) || ""}
                        </div>
                      </div>
                    </div>
                  )}
                  {((user &&
                    user.country === "ca" &&
                    user.membership &&
                    user.membership.percent_discount &&
                    user.membership.percent_discount > 0) ||
                    (cart &&
                      cart.any_order_service_lacks_price &&
                      user &&
                      user.membership &&
                      user.membership.plan_name !== "Basic" &&
                      user.membership.percent_discount > 0)) && (
                    <div className="row-space-between">
                      <div className="promotional-discount">{t("premiumMembershipBenefit")}</div>
                      <div className="font-bold">-{user.membership.percent_discount}%</div>
                    </div>
                  )}
                  {user && user.country !== "ca" && cart && cart.membership_discount > 0 && (
                    <div className="row-space-between">
                      <div className="promotional-discount">{t("premiumMembershipDiscount")}</div>
                      <div className="font-bold" style={{ color: "#282828" }}>
                        -${Number(cart.membership_discount).toFixed?.(2)}
                      </div>
                    </div>
                  )}
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
                      <Image src={priceTagBlack} className="promo-image" />
                      {t("addPromoCode")}
                    </div>
                    <ApplyPromotionV2 cart={cart} />
                  </div>
                  {user && user.country !== "ca" && (
                    <>
                      {cart && !cart.any_order_service_lacks_price && (
                        <>
                          <div className="row-space-between">
                            <div style={{ color: "#616161" }}>{t("subtotal")}</div>
                            <div className="membership-discount">
                              ${Number(sub_total).toFixed?.(2)}
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}
                  <div className="row-space-between">
                    <div style={{ color: "#616161" }}>Transaction Fee</div>
                    {!cart.any_order_service_lacks_price ? (
                      <div className="membership-discount">${cart.transaction_fee}</div>
                    ) : (
                      <p style={{ fontWeight: "bold", margin: 0 }}>Priced at shop</p>
                    )}
                  </div>
                  {user && user.country !== "ca" ? (
                    <>
                      {cart && !cart.any_order_service_lacks_price && (
                        <>
                          <div className="row-space-between">
                            <div style={{ color: "#616161" }}>{t("taxes")}</div>
                            <div className="membership-discount">
                              $
                              {Number(
                                Number(sub_total) * Number(cart.combined_sales_tax_from_service)
                              ).toFixed?.(2)}
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </AccordionContent>
            </Accordion>
            {(showMarketingCheckbox ||
              (!(user?.marketing_opt_in || false) && getSubdomain() === EBAY)) && (
              <>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <b style={{ textAlign: "left" }}>
                    Join over 1 million drivers who trust CarAdvise and get exclusive savings on
                    future maintenance
                  </b>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "baseline",
                      gap: "5px"
                    }}
                  >
                    <Checkbox
                      checked={marketingOptIn}
                      onChange={handleMarketingOptIn}
                      className="custom-orange-checkbox"
                    />
                    <p style={{ textAlign: "left", margin: 0, marginTop: "24px" }}>
                      Yes, send me my promo code to save 10% off my next service.
                    </p>
                  </div>
                </div>
              </>
            )}
            {showUpsellBanner() && (
              <div className="activate-membership activate-membership--no-padding">
                <div className="feature-list">
                  <div className="membership-row">
                    <p className="membership-fee-title">Membership fee</p>
                    <p className="price">${membership.price} / month</p>
                  </div>

                  {upsellMembershipFeatures.map((feature, i) => (
                    <div className="feature-item" key={i}>
                      <Tick />
                      <p className="upsell-feature-text">{feature}</p>
                    </div>
                  ))}

                  <Button
                    fluid
                    loading={isSubmitting}
                    onClick={upsellMembershipBannerClick}
                    className="primary-button upsell-cta-button"
                  >
                    Join & save
                  </Button>
                </div>
              </div>
            )}
            <div>
              <div className="row-space-between estimated-total">
                <div>{t("estimatedTotal")}</div>
                {user && user.country !== "ca" && cart && cart.estimated_total > 0 ? (
                  <div>${Number(cart.estimated_total).toFixed?.(2)}</div>
                ) : (
                  <div style={{ fontSize: "20px" }}>
                    <PricedAtShop />
                  </div>
                )}
              </div>
              {user && user.country !== "ca" && cart && !cart.any_order_service_lacks_price && (
                <div className="row-flex-start excludes-sales">
                  *{t("subjectToChangeBasedOnFinalWorkOrder")}
                </div>
              )}
            </div>

            {user &&
              user.country !== "ca" &&
              cart &&
              !cart.any_order_service_lacks_price &&
              cart.total_savings > 0 && (
                <>
                  <div className="row-space-between" style={{ fontWeight: 500, fontSize: "14px" }}>
                    <div>{t("totalSavings")}</div>
                    <div>${Number(cart?.total_savings).toFixed?.(2) || ""}</div>
                  </div>
                </>
              )}
          </div>
          <div className="action_button">
            <Button
              fluid
              loading={isSubmitting}
              onClick={onSubmit}
              disabled={canBook()}
              className="primary-button"
            >
              {isEbayTireOrder(cart)
                ? t("confirmTireInstall")
                : cart?.is_walk_in
                ? t("confirmMyVisit")
                : t("confirmServiceRequest")}
            </Button>
          </div>
        </div>
      ) : (
        <LoadingComponent />
      )}
      {!isEbay() && isCart && <UpsellServices />}

      {isMobile ? (
        <BottomSheet
          open={openModal}
          onDismiss={() => {}}
          snapPoints={({ minHeight }) => minHeight}
          draggable={false}
        >
          <AddPaymentDetails asModal={true} closeModalHandler={() => setOpenModal(false)} />
        </BottomSheet>
      ) : (
        <Modal open={openModal} className="add-payment-details-modal">
          <Modal.Content>
            <AddPaymentDetails asModal={true} closeModalHandler={() => setOpenModal(false)} />
          </Modal.Content>
        </Modal>
      )}
    </>
  )
}

function mapStateToProps(state, props) {
  const user = state.user
  let cart
  const braintreePaymentMethods = Array.isArray(state?.paymentMethods?.braintreePaymentMethods)
    ? state.paymentMethods.braintreePaymentMethods.filter((method) => method?.type !== "ach")
    : []
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)
  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let updatedCartData = getUpdatedCart(user, order, props)
  if (updatedCartData) {
    cart = updatedCartData.cart
  } else {
    cart = user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
  }

  return {
    braintreePaymentMethods: braintreePaymentMethods,
    user: state.user,
    cart: cart,
    isCart: updatedCartData.isCart,
    vehicle: activeVehicle,
    activeVehicle: activeVehicle,
    membershipData: state.membershipData.availableMembershipPlans,
    order
  }
}

export default withRouter(
  connect(mapStateToProps, {
    createOrder,
    me,
    updateOrder,
    optInForMarketing,
    updateInfo,
    getPaymentMethods
  })(withTranslation("serviceRequest")(ReviewRequest))
)
